/**
 * Who gets their impressions logged: every session with an id.
 *
 * A click-through rate is `clicks / impressions`, and both sides must come from
 * the same people. Every listing_view and listing_hover carries `sampled` from
 * this decision, and an impression is only written when it is true, so a rate
 * computed over `sampled = 1` clicks always matches its impressions.
 *
 * There used to be a rate here. 25% of sessions until 2026-10-30, sized against
 * a 3M-rows-a-month guess; the real volume at 100% is ~500k a month. While it
 * was partial, any click-through that counted ALL views over sampled
 * impressions read 4x high (the UI test card, fixed 2026-11-02), and the switch
 * to 100% looked like a -69% crash. No rate means no 1/rate to forget. Rows
 * before 2026-10-30 still hold a 25% sample: read their rates over
 * `sampled = 1` views.
 */

/**
 * Is this session having its impressions logged?
 *
 * An empty session id is not. A missing id means the tracker could not
 * establish one (blocked storage, server-side render); logging those would add
 * impressions that no click could ever be joined to, which biases the rate
 * downward rather than leaving it alone.
 */
export function isSessionSampled(sessionId: string | null | undefined): boolean {
  return Boolean(sessionId);
}
